import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { AiCallProduct } from './ai-call.service';
import { AiComparisonRow, AiComparisons, AiModelSummaryRow } from './ai-comparison.types';
import { AiEvaluationDetailResponse } from './ai-evaluations.types';

/** Re-running a file's AI calls on other models (Ops surface; N4). */
@Injectable({ providedIn: 'root' })
export class AiComparisonService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiUrl}/api/ai/comparisons`;

  forFile(product: AiCallProduct, targetId: string): Observable<AiComparisons> {
    return this.http.get<AiComparisons>(`${this.base}/${product}/${targetId}/`);
  }

  /** Starts one in the background. 409 with `detail` when it may not start. */
  start(
    product: AiCallProduct,
    targetId: string,
    baseline: string,
    model: string,
  ): Observable<AiComparisonRow> {
    return this.http.post<AiComparisonRow>(`${this.base}/${product}/${targetId}/`, {
      baseline,
      model,
    });
  }

  call(
    product: AiCallProduct,
    targetId: string,
    shortId: string,
  ): Observable<AiEvaluationDetailResponse> {
    return this.http.get<AiEvaluationDetailResponse>(
      `${this.base}/${product}/${targetId}/calls/${shortId}/`,
    );
  }

  /** Admin only: every model's record, per kind of AI call. */
  modelSummary(): Observable<{ rows: AiModelSummaryRow[] }> {
    return this.http.get<{ rows: AiModelSummaryRow[] }>(
      `${environment.apiUrl}/api/admin/ai-evaluations/by-model/`,
    );
  }
}
